const SHOWN_VALUES = 40;

type Props = { values: { value: string; count: number }[] };

export function StoreValueChips({ values }: Props) {
  if (values.length === 0) return null;
  const hidden = values.length - SHOWN_VALUES;
  return (
    <ul aria-label="Store values" className="flex flex-wrap gap-1.5">
      {values.slice(0, SHOWN_VALUES).map(({ value, count }) => (
        <li
          key={value}
          className="max-w-full break-words rounded-md bg-slate-100 px-2 py-0.5 text-xs text-slate-800 [overflow-wrap:anywhere] dark:bg-slate-800 dark:text-slate-200"
        >
          {value}
          {count > 1 && (
            <span className="ml-1 tabular-nums text-slate-500 dark:text-slate-400">
              ×{count}
            </span>
          )}
        </li>
      ))}
      {hidden > 0 && (
        <li className="px-1 py-0.5 text-xs text-slate-500 dark:text-slate-400">
          +{hidden} more in the JSON
        </li>
      )}
    </ul>
  );
}
